import request from '../../../axios';

export const getUserPromotedAdverstisment = async (guid?: string) => {
  const {data}: {data: Array<IUserPromotedAdverstismentData>} =
    await request.get(`/api/v2/store/user-promoted-advertisement/${guid}`);
  return data;
};
